import Banner from "@/components/ui/banner";
import { Button } from "@/components/ui/button";
import {
  isAnthropicFamilyStructuredOutputProvider,
  jsonSchemaContainsOneOf,
} from "@/components/SchemaEditor/utils";

const ANTHROPIC_STRUCTURED_OUTPUTS_DOCS =
  "https://platform.claude.com/docs/en/build-with-claude/structured-outputs";

export interface OneOfStructuredOutputWarningProps {
  providerName: string | null | undefined;
  // MobX store `definition` or any JSON Schema object to scan for `oneOf`
  schema: object;
}

/**
 * Claude structured outputs support `anyOf` / `allOf` (with limits) but do not document `oneOf`.
 * Shown when editing a schema for Anthropic/Bedrock-Claude and the current schema uses `oneOf`.
 */
const OneOfStructuredOutputWarning = ({
  providerName,
  schema,
}: OneOfStructuredOutputWarningProps) => {
  if (!isAnthropicFamilyStructuredOutputProvider(providerName)) {
    return null;
  }
  if (!jsonSchemaContainsOneOf(schema)) {
    return null;
  }

  return (
    <Banner className="w-full border-amber-400 bg-amber-50 text-amber-950 [&_*]:text-amber-950">
      <span>
        Claude structured outputs may reject or not support{" "}
        <code className="whitespace-nowrap rounded bg-amber-100 px-1.5 py-0.5 font-mono text-sm">
          oneOf
        </code>
        . Prefer{" "}
        <code className="whitespace-nowrap rounded bg-amber-100 px-1.5 py-0.5 font-mono text-sm">
          anyOf
        </code>{" "}
        with discriminant fields (for example{" "}
        <code className="whitespace-nowrap rounded bg-amber-100 px-1.5 py-0.5 font-mono text-sm">
          const
        </code>{" "}
        on a <code className="font-mono text-sm">type</code> property). See provider docs for the
        supported JSON Schema subset.{" "}
      </span>
      <Button
        variant="link"
        className="h-auto shrink-0 px-1 py-0 align-baseline text-amber-900 underline"
        onClick={() => window.open(ANTHROPIC_STRUCTURED_OUTPUTS_DOCS, "_blank")}
      >
        Anthropic: Structured outputs
      </Button>
    </Banner>
  );
};

export default OneOfStructuredOutputWarning;
